import { render, staticRenderFns } from "./_token.vue?vue&type=template&id=3250400e&scoped=true&"
import script from "./_token.vue?vue&type=script&lang=js&"
export * from "./_token.vue?vue&type=script&lang=js&"
import style0 from "./_token.vue?vue&type=style&index=0&id=3250400e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3250400e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VForm,VImg})
